import axios from "axios";

const instance = axios.create({});

const apiGetConfig = "apiGetConfig";
const apiGetCompletePersonalization = "apiGetCompletePersonalization";
const apiGet = "apiGet";
const apiUpload = "apiUpload";
const apiChangeOption = "apiChangeOption";
const packingGetData = "packingGetData";
const packingGetPdf = "packingGetPdf";
const packingGetCf2 = "packingGetCf2";
const checkPreflight = "checkPreflight";
const deleteFile = "deleteFile";
const getPersonalizeUrl = "getPersonalizeUrl";
const getPdfUploadPreview = "getPdfUploadPreview";
const connectUpload = "connectUpload";
const rearrangePdf = "rearrangePdf";
const quotationUrl = "quotationUrl";

export default {
  instance,
  apiGetConfig,
  apiGetCompletePersonalization,
  apiGet,
  apiUpload,
  apiChangeOption,
  packingGetData,
  packingGetPdf,
  packingGetCf2,
  checkPreflight,
  deleteFile,
  getPersonalizeUrl,
  getPdfUploadPreview,
  connectUpload,
  rearrangePdf,
  quotationUrl
};
